import { FC } from 'react';

import Modal from '@z-components/atoms/Modal';

import styles from './TierExplanationModal.module.scss';

const TRANSLATIONS = {
  en: {
    proTier: 'Pro Tier',
    tierExplanationText:
      '"Pros are awarded the ranks of New User, Bronze, Silver, Gold, Platinum, and Diamond for completing various missions in Pro Dojo. The higher ranks are the sign of a pro with a proven track record and reputation!',
  },
  ja: {
    proTier: 'プロランク',
    tierExplanationText:
      '「プロ道場」というプロ向けテストで様々なミッションクリアに応じ、ニューユーザー・ブロンズ・シルバー・ゴールド・プラチナ・ダイヤモンドのランクがプロに付与されます。上級ランクはゼヒトモ実績も評判も伴う優秀プロの証です！',
  },
};

const tiers = [
  {
    name: 'new-user',
    text: {
      en: 'New User',
      ja: 'ニューユーザー',
    },
  },
  {
    name: 'bronze',
    text: {
      en: 'Bronze',
      ja: 'ブロンズ',
    },
  },
  {
    name: 'silver',
    text: {
      en: 'Silver',
      ja: 'シルバー',
    },
  },
  {
    name: 'gold',
    text: {
      en: 'Gold',
      ja: 'ゴールド',
    },
  },
  {
    name: 'platinum',
    text: {
      en: 'Platinum',
      ja: 'プラチナ',
    },
  },
  {
    name: 'diamond',
    text: {
      en: 'Diamond',
      ja: 'ダイアモンド',
    },
  },
];

interface Props {
  handleModalDismiss: () => void;
  language: 'en' | 'ja';
}
const TierExplanationModal: FC<Props> = ({ language, handleModalDismiss }) => (
  <Modal
    modalName="verification-help"
    hasMaxWidth={true}
    isCloseButtonHidden={true}
    isModalRounded={true}
    onDismiss={handleModalDismiss}
  >
    <p className={styles['modal-title']}>{TRANSLATIONS[language].proTier}</p>
    <p className={styles['modal-content']}>{TRANSLATIONS[language].tierExplanationText}</p>
    <div className={styles['pro-tier-icons-container']}>
      {tiers.map(({ name, text }) => (
        <div key={name} className={styles['pro-tier-icon']}>
          <img alt={`Tier ${text.en}`} src={`/static/images/tiers/${name}.svg`} />
          <p>{text[language]}</p>
        </div>
      ))}
    </div>
  </Modal>
);

export default TierExplanationModal;
export type { Props as TierExplanationModal };
